import { Illustration, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

export function NewsFeedEmptyPageState() {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      spacing={8}
      height="100%"
      textAlign="center"
      sx={{ textWrap: "balance" }}
    >
      <Illustration type="person-destructive" />
      <Text variant="body1">Nothing here, add some friends to see their activity!</Text>
    </Stack>
  );
}
